/* global React, Icon */
const { useState: useStateFaq } = React;

function Faq() {
  const [open, setOpen] = useStateFaq(0);
  const t = (k) => window.i18n.t(k);

  const items = () => [
    { q: t("faq.item.1.q"), a: t("faq.item.1.a") },
    { q: t("faq.item.2.q"), a: t("faq.item.2.a") },
    { q: t("faq.item.3.q"), a: t("faq.item.3.a") },
    { q: t("faq.item.4.q"), a: t("faq.item.4.a") },
    { q: t("faq.item.5.q"), a: t("faq.item.5.a") },
    { q: t("faq.item.6.q"), a: t("faq.item.6.a") },
  ];

  return (
    <section className="section" id="faq">
      <div className="container">
        <div className="faq-grid">
          <div>
            <span className="eyebrow">{t("faq.eyebrow")}</span>
            <h2 style={{ marginTop: 16 }}>{t("faq.h2")}</h2>
            <p className="faq-sub">{t("faq.sub")}</p>
            <a href="#cta" className="link-arrow" style={{ marginTop: 20, display: "inline-flex" }}>
              <Icon name="tg" size={16} /> {t("faq.cta.ask")} <Icon name="arrow" size={14} />
            </a>
          </div>
          <div className="faq-list">
            {items().map((item, i) => (
              <div className={`faq-item ${open === i ? "open" : ""}`} key={i}>
                <button
                  className="faq-q"
                  onClick={() => setOpen(open === i ? -1 : i)}
                  aria-expanded={open === i}
                >
                  {item.q}
                  <span className="ic">
                    <Icon name="plus" size={16} stroke={2} />
                  </span>
                </button>
                <div className="faq-a">
                  <div className="faq-a-inner">
                    <p>{item.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

window.Faq = Faq;
